import { FC } from 'react'
import { Page } from '../../../components/Page'
import { useNavigate } from 'react-router-dom'
import { CAMERA_OVERVIEW_URL, CAMERA_OVERVIEW_URL_WITH_CAMERA_ID } from '../CameraOverviewPage/cameraOverviewEnums'

export const MonitoringModerationPage: FC = () => {
  const navigate = useNavigate()

  const handleSearch = (locationId: string, cameraId?: string) => {
    if (cameraId) {
      navigate(CAMERA_OVERVIEW_URL_WITH_CAMERA_ID(locationId, cameraId))
    } else {
      navigate(CAMERA_OVERVIEW_URL(locationId))
    }
  }

  return (
    <Page
      title="Monitoring Moderation"
      showChildrenWhenMissingLocation={true}
      shouldAllowCameraIdSearch={true}
      onSearch={handleSearch}
      data-testid="monitoring-moderation-page"
    />
  )
}
